"use client"

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"

import { cn } from "@garagem/ui/lib/utils"

type LabelSize = "sm" | "section"

interface LabelProps extends React.ComponentProps<typeof LabelPrimitive.Root> {
  size?: LabelSize
}

function Label({ className, size = "sm", ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        size === "sm" && "text-sm",
        size === "section" && "text-base font-semibold text-foreground",
        className,
      )}
      {...props}
    />
  )
}

export { Label }
